<script>
import Form, { formCreate } from '../../../../../components/form';
import request from '../../../../../utils/request';

import TextForm from './text_form.vue';

formCreate.component('TextForm', TextForm);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      rule: [],
    };
  },
  async created() {
    // 获取规则
    await this.getFormRule('adjustment_form', 'CRM20250513000000002');

    // 省、市、区
    const newProvinceCode = this.getRule('newProvinceCode');
    const newCityCode = this.getRule('newCityCode');
    const newDistrictCode = this.getRule('newDistrictCode');
    newProvinceCode.restful = '/mdm/mdmRegionController/selectStartWithProvince';
    newProvinceCode.optionsKey = { label: 'regionName', value: 'regionCode' };
    newProvinceCode.props = {
      ...newProvinceCode.props,
      remoteParams: 'regionName',
    };

    newCityCode.optionsKey = { label: 'regionName', value: 'regionCode' };
    newDistrictCode.optionsKey = { label: 'regionName', value: 'regionCode' };

    newProvinceCode.restfulParams = {
      regionLevel: '1',
    };
    newCityCode.restful = '/mdm/mdmRegionController/selectStartWithProvince';
    newCityCode.props = {
      ...newCityCode.props,
      filterable: true,
      remote: true,
      remoteParams: 'regionName',
    };
    newCityCode.refresh = true;
    newDistrictCode.restful = '/mdm/mdmRegionController/selectStartWithProvince';
    newDistrictCode.props = {
      ...newDistrictCode.props,
      filterable: true,
      remote: true,
      remoteParams: 'regionName',
    };
    newDistrictCode.refresh = true;
    newProvinceCode.on = {
      change: (val) => {
        if (val) {
          this.setValue({
            newProvinceCode: val,
            newProvinceName: ((newProvinceCode.options || []).find((v) => v.value === val) || {}).label || null,
          });
          this.disabled(false, ['newCityCode']);
        } else {
          this.setValue({
            newProvinceCode: null,
            newProvinceName: null,
          });
          this.disabled(true, ['newCityCode', 'newDistrictCode']);
        }
        newCityCode.value = '';
        newDistrictCode.value = '';
        if (!val) {
          newCityCode.restful = '';
          newDistrictCode.restful = '';
          return;
        }
        newCityCode.restfulParams = {
          parentCode: val,
        };
      },
    };
    newCityCode.on = {
      change: (val) => {
        if (val) {
          this.setValue({
            newCityCode: val,
            newCityName: ((newCityCode.options || []).find((v) => v.value === val) || {}).label || null,
          });
          this.disabled(false, ['newDistrictCode']);
        } else {
          this.setValue({
            newCityCode: null,
            newCityName: null,
          });
          this.disabled(true, ['newDistrictCode']);
        }
        newDistrictCode.value = '';
        if (!val) {
          newDistrictCode.restful = '';
          return;
        }
        newDistrictCode.restfulParams = {
          parentCode: val,
        };
      },
    };
    newDistrictCode.on = {
      change: (val) => {
        if (val) {
          this.setValue({
            newDistrictCode: val,
            newDistrictName: ((newDistrictCode.options || []).find((v) => v.value === val) || {}).label || null,
          });
        } else {
          this.setValue({
            newDistrictCode: null,
            newDistrictName: null,
          });
        }
      },
    };

    this.reload(this.rule);
    this.disabled(true, ['newCityCode', 'newDistrictCode']);
  },
  methods: {
    /**
     * 表单渲染完成后回调
     */
    formComplete() {},
    // 提交
    submit() {
      const formData = this.getFormData();
      if (formData) {
        const url = '/mdm/mdmRegionController/userUpdateOldRegion';
        const params = formData;
        params.oldId = this.formConfig.row.id;
        delete params.title;
        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
/deep/.el-col-md-24 {
  margin-left: -20px !important;
}
/deep/.el-form-item__label {
  margin-left: -30px !important;
}
</style>
